import {JsonObject, JsonProperty} from 'json2typescript';
import {EmptyControl, NotBlank} from '@hvlng/framework-bff/core';
import {FileMetadataModel} from './file-metadata-model';

@JsonObject('KovanHrFileOwnershipModel')
export class FileOwnershipModel {
    @NotBlank()
    @JsonProperty('uuid', String, true)
    fileUuid: string = null;

    @EmptyControl()
    @JsonProperty('ownerUuid', String, true)
    ownerUuid: string = null;
     @EmptyControl()
    @JsonProperty('fileMetadata', FileMetadataModel, true)
    fileMetadata: FileMetadataModel = new FileMetadataModel();
}
